// TODO: delete when new customize UI enabled for everyone
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CustomPagesStore from '../../stores/CustomPagesStore';
import SnackStore from '../../stores/SnackStore';
import { ConsolePage } from '../ConsoleFragments';
import ContentFilteringPage from '../BlockPage/ContentFilteringPage';
import MaliciousThreatPage from '../BlockPage/MaliciousThreatPage';
import EditCustomPage from './EditCustomPage';
import ConsoleStore from '../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';

class ConsoleCustomPages extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        customPages: CustomPagesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    componentWillMount() {
        this.props.customPages.load()
            .catch((error) => error && this.props.snack.showError(`Failed to load. ${error.message}`));
    }

    render() {
        const { customPages, console } = this.props;
        const readOnly = console.authority === ROLE_READ_ONLY.value;

        return <ConsolePage title="Block Pages">
            <EditCustomPage
                title="Content Filtering"
                enableInfo="Display Proofpoint's default content filtering block page
                            or customize the page to match your company's needs."
                pageComponent={ContentFilteringPage}
                store={customPages.contentFiltering}
                readOnly={readOnly}
            />
            {console.hasBrowserOrEmailLicense() || console.hasSaasIsolation() ? <EditCustomPage
                title="Malicious Threat"
                enableInfo="Display Proofpoint's default malicious threat block page
                            or customize the page to match your company's needs."
                pageComponent={MaliciousThreatPage}
                store={customPages.maliciousThreat}
                readOnly={readOnly}
            /> : null}
        </ConsolePage>;
    }
}

export default inject('console', 'customPages', 'snack')(observer(ConsoleCustomPages));
